import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const exampleRoutes = useRouter().getRoutes().filter(route => route.path.includes('examples/'))


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exampleRoutes), (route) => {
    return (_openBlock(), _createBlock(_component_router_link, {
      to: route.path,
      key: route.path
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(route.name), 1)
      ]),
      _: 2
    }, 1032, ["to"]))
  }), 128))
}
}

})